<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" class="p-button-danger" pButton icon="pi pi-times" label="No" (click)="cd.reject()"></button>
    <button type="button" pButton icon="pi pi-check" label="Si" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>

<div class="surface-section px-4 py-5 md:px-6 lg:px-8">
  <label class="w-full text-900 text-4xl">I tuoi documenti</label>
</div>


<div class="w-full flex flex-wrap px-2 md:px-4 lg:px-6">
<p-accordion [activeIndex]="0" class="w-full" [styleClass]="'primary w-full'" [multiple]="true">
       <div *ngFor="let sezioni of lstSezioni" class="w-full">
        <p-accordionTab header="{{sezioni.SezioneNome}}" (selectedChange)="selectTabSezione(sezioni.IdSezione)" class="w-full" [tabStyleClass]="'w-full'">
          <div class="col-12 flex">
            <p-table  [value]="lstDocument"
                      [styleClass]="'primary'"
                      [tableStyle]="{ 'min-width': '50rem' }"
                      [paginator]="true"
                      [rows]="10"
                      [lazy]="true"
                      (onLazyLoad)="getDocumentListPaged($event, sezioni.IdSezione)"
                      paginatorDropdownAppendTo="body"
                      [scrollable]="true"
                      [totalRecords]="totalDocument"
                      currentPageReportTemplate="Elementi totali : {totalRecords}"
                      [rowsPerPageOptions]="[10, 25, 50]"
                      *ngIf="idSezioneSelected == sezioni.IdSezione">
              <ng-template pTemplate="body" let-document>
                <tr>
                  <td>{{ document.DocumentoTipo }}</td>
                  <td>{{ document.NomeDocumento}}</td>
                  <td>{{ document.DataDalStr}}</td>
                  <td>{{ document.DataAlStr}}</td>
                  <td>{{ document.DataRichiestaRinnovoStr }}</td>
                  <td>{{ document.RinnovoPSRif }}</td>
                  <td>
                    <div *ngIf="document.IdDocumentoTipo == 6">
                      <p-checkbox id="privacyCheck"
                                  [binary]="true"
                                  name="privacyCheck"
                                  [required]="true"
                                  [(ngModel)]="document.InRinnovo"></p-checkbox>
                      <i class="pi pi-save ml-2 font-bold cursor-pointer" [pTooltip]="'Salva'" (click)="updateExtraInfo(document)"></i>
                    </div>
                  </td>
                  <td>{{ document.DateInsStr }}</td>
                  <td>{{ document.UserIns }}</td>
                  <td>
                    <div class="w-full flex">
                      <i class="pi pi-search mr-2 font-bold cursor-pointer" [pTooltip]="'Visualizza'" (click)="showDocument(document)"></i>
                      <i class="pi pi-download ml-2 mr-2 font-bold cursor-pointer" [pTooltip]="'Scarica'" (click)="downloadDocument(document)"></i>
                      <i class="pi pi-trash ml-2 font-bold cursor-pointer" [pTooltip]="'Elimina'" (click)="deleteDocument(document)" *ngIf="document.CanDelete"></i>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="paginatorleft">
                <p-button type="button" [label]="'Aggiungi doc.'" icon="pi pi-plus" styleClass="p-button-text" (click)="addNewDocument()" *ngIf="canUploadDocument"></p-button>
              </ng-template>
            </p-table>
          </div>
        </p-accordionTab>
       </div>
  <div *ngIf="lstSezioni.length == 0">
    <label> Nessun documento inserito </label>
  </div>


</p-accordion>
</div>




<p-dialog [header]="'Visualizza documento'" [(visible)]="showModalShowDocument" [modal]="true" [style]="{width: '90vw'}"
          [draggable]="false" [resizable]="false">
  <app-document-show  *ngIf="showModalShowDocument"
                      [blob]="blob"
                      [src]="src"
                      [fileName]="fileName"
                      [FileIdEnc]="fileIdEnc"
  ></app-document-show>
  <ng-template pTemplate="footer">
  </ng-template>
</p-dialog>

<p-dialog [header]="'Inserisci documento'" [(visible)]="showModalInsertDocument" [modal]="true" [style]="{width: '50vw'}"
          [draggable]="false" [resizable]="false">
  <app-document-insert *ngIf="showModalInsertDocument"
                        [filtroTipoDocumenti]="3"
                        (onSaveDocument)="onSaveDocument()"></app-document-insert>
</p-dialog>
